import getTranslationOptions from './getTranslationOptions';
import { TranslationOptions } from 'owa-outlook-service-options';
import isLanguageSupported from './isLanguageSupported';

// If user has invalid target language selection, reverts option back to display language
export default function checkTargetLanguageValid() {
    const options: TranslationOptions = getTranslationOptions();

    if (options.targetLanguage !== null && !isLanguageSupported(options.targetLanguage)) {
        options.targetLanguage = null;
    }
}
